import { Divider } from 'antd'

import SOBTIDLOGO from '../images/SOBTID LOGO.png'
import KCCLOGO from '../images/KCC Logo.png'
import KECLOGO from '../images/KEC Logo.png'
import NEWKRULOGO from '../images/Newkru Logo.png'
import GSBLOGO from '../images/GSB LOGO.png'
import KSLOGO from '../images/KS LOGO.png'
import DEEPAUTO_LOGO from '../images/DeepAuto_Logo.png'

export default function Experience() {
    return <>
        <div style={{ marginBottom: 12, display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
            <span style={{ textAlign: 'right' }}>
                <h2 style={{ margin: 0 }}><a href='https://www.deepauto.ai'>DeepAuto.ai</a></h2>
                <h3 style={{ margin: 0 }}>AI Research Engineer (Intern)</h3>
                <h5 style={{ color: '#4caf50' }}>FROM 2024.01 TO 2024.05</h5>
            </span>
            <img style={{ marginLeft: 24 }} src={DEEPAUTO_LOGO} alt='DeepAuto.ai LOGO' height='48' />
        </div>
        <div style={{ marginBottom: 12, display: 'flex', alignItems: 'center' }}>
            <img style={{ marginRight: 24 }} src={SOBTIDLOGO} alt='SOBTID LOGO' height='48' />
            <span>
                <h2 style={{ margin: 0 }}><a href="https://www.sobtid.me">Sobtid Edutainment Co., Ltd.</a></h2>
                <h3 style={{ margin: 0 }}> Front-end Developer</h3>
                <h5 style={{ color: '#4caf50' }}>FROM 2017.05 TO 2018.08</h5>
            </span>
        </div>
        <div style={{ marginBottom: 12, display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
            <span style={{ textAlign: 'right' }}>
                <h2 style={{ margin: 0 }}>Korean Square</h2>
                <h3 style={{ margin: 0 }}>Creator</h3>
                <h5 style={{ color: '#4caf50' }}>FROM 2016.02 TO PRESENT</h5>
            </span>
            <img style={{ marginLeft: 24 }} src={KSLOGO} alt='KOREAN SQUARE LOGO' height='72' />
        </div>
        <Divider>EFFORT WILL NOT BETRAY YOU</Divider>
        <div style={{ marginBottom: 12, display: 'flex', alignItems: 'center' }}>
            <img style={{ marginRight: 24 }} src={KCCLOGO} alt='KOREAN CULTURAL CENTER LOGO' height='56' />
            <span>
                <h2 style={{ margin: 0 }}>Korean Cultural Center in Thailand</h2>
                <h3 style={{ margin: 0 }}> Intern</h3>
                <h5 style={{ color: '#4caf50' }}>FROM 2016.11 TO 2017.02</h5>
            </span>
        </div>
        <div style={{ marginBottom: 12, display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
            <span style={{ textAlign: 'right' }}>
                <h2 style={{ margin: 0 }}>Korean Education Center in Thailand</h2>
                <h3 style={{ margin: 0 }}> Part-time Job for TOPIK Registration</h3>
                <h5 style={{ color: '#4caf50' }}>IN 2016.01, 2016.08, 2016.09</h5>
            </span>
            <img style={{ marginLeft: 24 }} src={KECLOGO} alt='KOREAN EDUCATION CENTER LOGO' height='42' />
        </div>
        <div style={{ marginBottom: 12, display: 'flex', alignItems: 'center' }}>
            <img style={{ marginRight: 24 }} src={NEWKRULOGO} alt='NEWKRU LOGO' height='36' />
            <span>
                <h2 style={{ margin: 0 }}>NewKru Co., Ltd.</h2>
                <h3 style={{ margin: 0 }}> Web Developer (Cooperative Education)</h3>
                <h5 style={{ color: '#4caf50' }}>FROM 2015.06 TO 2015.11</h5>
            </span>
        </div>
        <div style={{ marginBottom: 12, display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
            <span style={{ textAlign: 'right' }}>
                <h2 style={{ margin: 0 }}>Government Savings Bank (Kasetsart U. Branch)</h2>
                <h3 style={{ margin: 0 }}> Internship Student</h3>
                <h5 style={{ color: '#4caf50' }}>FROM 2011.03 TO 2011.05</h5>
            </span>
            <img style={{ marginLeft: 24 }} src={GSBLOGO} alt='GOVERNMENT SAVINGS BANK LOGO' height='72' />
        </div>
    </>
}